import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ICprInstructor, ICprCertifiedStaff } from '../models/cprFirstAidAed';
import { ErrorService } from '../helpers/errorService';

type Envelope<T> = { has_error: boolean, message: string, data: T };

@Injectable({
    providedIn: 'root'
})
export class CprFirstAidAedService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    // --- Instructors ---
    getInstructors(buildingId: string): Observable<Envelope<ICprInstructor[]>> {
        const url = environment.apiBaseUrl + endpoints.getCprInstructors.replace(':buildingId', buildingId);
        return this.http.get<Envelope<ICprInstructor[]>>(url).pipe(catchError(this.errorService.handleError));
    }

    createInstructor(buildingId: string, data: Partial<ICprInstructor>): Observable<Envelope<any>> {
        const url = environment.apiBaseUrl + endpoints.createCprInstructor.replace(':buildingId', buildingId);
        return this.http.post<Envelope<any>>(url, data).pipe(catchError(this.errorService.handleError));
    }

    updateInstructor(buildingId: string, itemId: string, data: Partial<ICprInstructor>): Observable<Envelope<any>> {
        const url = environment.apiBaseUrl + endpoints.updateCprInstructor.replace(':buildingId', buildingId).replace(':itemId', itemId);
        return this.http.put<Envelope<any>>(url, data).pipe(catchError(this.errorService.handleError));
    }

    deleteInstructor(buildingId: string, itemId: string): Observable<Envelope<any>> {
        const url = environment.apiBaseUrl + endpoints.deleteCprInstructor.replace(':buildingId', buildingId).replace(':itemId', itemId);
        return this.http.delete<Envelope<any>>(url).pipe(catchError(this.errorService.handleError));
    }

    // --- Certified staff ---
    getCertifiedStaff(buildingId: string): Observable<Envelope<ICprCertifiedStaff[]>> {
        const url = environment.apiBaseUrl + endpoints.getCprCertifiedStaff.replace(':buildingId', buildingId);
        return this.http.get<Envelope<ICprCertifiedStaff[]>>(url).pipe(catchError(this.errorService.handleError));
    }

    createCertifiedStaff(buildingId: string, data: Partial<ICprCertifiedStaff>): Observable<Envelope<any>> {
        const url = environment.apiBaseUrl + endpoints.createCprCertifiedStaff.replace(':buildingId', buildingId);
        return this.http.post<Envelope<any>>(url, data).pipe(catchError(this.errorService.handleError));
    }

    updateCertifiedStaff(buildingId: string, itemId: string, data: Partial<ICprCertifiedStaff>): Observable<Envelope<any>> {
        const url = environment.apiBaseUrl + endpoints.updateCprCertifiedStaff.replace(':buildingId', buildingId).replace(':itemId', itemId);
        return this.http.put<Envelope<any>>(url, data).pipe(catchError(this.errorService.handleError));
    }

    deleteCertifiedStaff(buildingId: string, itemId: string): Observable<Envelope<any>> {
        const url = environment.apiBaseUrl + endpoints.deleteCprCertifiedStaff.replace(':buildingId', buildingId).replace(':itemId', itemId);
        return this.http.delete<Envelope<any>>(url).pipe(catchError(this.errorService.handleError));
    }
}
